import lodash from "lodash";

export function existAndHasValue<T>(value: T | null | undefined): value is T {
	return !lodash.isNil(value) && !lodash.isEmpty(value);
}

export function isValidEmail(email: string) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
